import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const urlSanitize = (url: string) =>
  url.replace(/[^"'+a-zA-Z0-9\u0590-\u05FF_.-]/g, ' ').trim();
